export default __webpack_public_path__ + "static/lynkeus-f45ebad00cfa71f5bf80f8f77162ab31.svg";